import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    table: {
        minWidth: 500,
    },
    tableContainer: {
        margin: '20px'
    },
    statusChooseContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        marginTop: '10px'
    },
    statusChooseElement: {
        margin: 'auto',
        fontSize: '15px',
        marginBottom: '20px'
    },
    dateContainer: {
        marginBottom: '15px'
    }
});

export default useStyles;
